export default __webpack_public_path__ + "static/media/h.c7e161f1.jpg";